import { useRef } from "react";

import {
  CallWithTranscript,
  ErrorText,
  LoadingIndicator,
} from "@/components";

import { useGetCallSignedAudioUrl } from "@/hooks/queries/useGetCallSignedAudioUrl";
import { Call } from "@/types";

export const StafferCallWithTranscript = ({
  callId,
  candidateFirstName,
  candidateLastName,
  jobTitle,
  transcriptLines,
}: {
  callId: string;
  candidateFirstName: string;
  candidateLastName: string;
  jobTitle: string;
  transcriptLines: NonNullable<Call["transcript"]>["transcriptLines"];
}) => {
  /* Database CRUD Operations */
  // Read
  const audioQuery = useGetCallSignedAudioUrl({ callId });

  /* React Hooks */
  // useRef
  const audioRef = useRef<HTMLAudioElement>(null);

  /* Render */
  const render = () => {
    if (audioQuery.isPending) return <LoadingIndicator variant="medium" />;
    if (audioQuery.isError) {
      return <ErrorText errorMessage="Error retrieving call audio." />;
    }

    return (
      <CallWithTranscript
        audioRef={audioRef}
        audioSrc={audioQuery.data}
        downloadFilename={`staffer-call-${candidateFirstName}-${candidateLastName}-${jobTitle}.mp3`
          .toLowerCase()
          .replace(/\s+/g, "-")}
        getRoleLabel={(role) =>
          role === "staffer" ? "Staffer" : candidateFirstName
        }
        transcriptLines={transcriptLines}
      />
    );
  };

  return render();
};
